import AsyncStorage from "@react-native-async-storage/async-storage";
import dayjs from "dayjs";
import "dayjs/locale/hr";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import isToday from "dayjs/plugin/isToday";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import updateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";
import _ from "lodash";
import { configure } from "mobx";
import { Platform } from "react-native";
import { z } from "zod";
import { initializeSentry } from "initializeSentry";
import { constants } from "./constants";
import { environment } from "./environment";
import { initializeI18n } from "./features/intl";
import { createQueryClient } from "./services/createQueryClient";
import { state } from "./store";
import { ignoreLogs } from "./utils/ignoreLogs";

export async function initialize() {
  // await AsyncStorage.clear();
  // console.log("[🤖] Cleared async storage");
  // throw new Error("This is an error");

  // Make sure this is always at the top of the initialize function
  await initializeSentry();

  const uniqueUserIdFromStorage = await AsyncStorage.getItem(
    constants.ASYNC_STORAGE_KEYS.UNIQUE_USER_ID,
  );

  console.log("[🤖] uniqueUserIdFromStorage", uniqueUserIdFromStorage);

  // on iOS we use the email as the unique user id, and on other platforms we use a random 8 character string
  const idSchema = z.string().min(8).or(z.string().email());
  const parseResponse = idSchema.safeParse(uniqueUserIdFromStorage);
  if (parseResponse.success) {
    console.log(
      "[🤖] Found valid unique user id in storage:",
      parseResponse.data,
    );

    state._uniqueUserId = parseResponse.data;
  } else {
    if (Platform.OS === "ios") {
      console.log(
        "[🤖] No valid unique user id found in storage. But we're on iOS so it will be generated after login",
      );
    } else {
      console.log(
        "[🤖] No valid unique user id found in storage, generating a new one",
      );
      // Generate a new unique user id of exactly 8 characters containing alphanumeric characters
      const uniqueUserId = _.times(8, () => {
        const charList = "abcdefghijklmnopqrstuvwxyz0123456789";
        return charList[Math.floor(Math.random() * charList.length)];
      }).join("");

      state._uniqueUserId = uniqueUserId;
      await AsyncStorage.setItem(
        constants.ASYNC_STORAGE_KEYS.UNIQUE_USER_ID,
        uniqueUserId,
      );
    }
  }

  // We mutate mobx state without actions in a couple of places so
  // this is should be called early in the initialize function
  configure({ enforceActions: "never" });

  const queryClient = createQueryClient();

  await initializeI18n();

  if (environment.DISABLE_LOGS) {
    ignoreLogs();
  }

  dayjs.extend(customParseFormat);
  dayjs.extend(isToday);
  dayjs.extend(localizedFormat);
  dayjs.extend(relativeTime);
  dayjs.extend(utc);
  dayjs.extend(isBetween);
  dayjs.extend(updateLocale);
  dayjs.extend(advancedFormat);

  return {
    queryClient,
  };
}
